export default __webpack_public_path__ + "static/media/legs-raised.7dcc3309.png";